function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createContainer } from 'unstated-next';
import { useState, useCallback, useRef, useMemo, useEffect } from 'react';
import useMergedState from "rc-util/es/hooks/useMergedState";
import { genColumnKey } from './utils';
import { noteOnce } from "rc-util/es/warning";

function useContainer() {
  var _props$columnsState3, _props$columnsState4, _props$columnsState8, _props$columnsState9;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var actionRef = useRef();
  /** 父 form item 的 name */

  var prefixNameRef = useRef();
  var propsRef = useRef(); // 共享状态比较难，就放到这里了

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      keyWords = _useState2[0],
      _setKeyWords = _useState2[1]; // 用于排序的数组


  var sortKeyColumns = useRef([]);

  var _useMergedState = useMergedState(function () {
    return props.size || props.defaultSize || 'middle';
  }, {
    value: props.size,
    onChange: props.onSizeChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      tableSize = _useMergedState2[0],
      setTableSize = _useMergedState2[1];
  /** 默认全选中 */


  var defaultColumnKeyMap = useMemo(function () {
    var _props$columns;

    var columnKeyMap = {};
    (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.forEach(function (_ref, index) {
      var key = _ref.key,
          fixed = _ref.fixed;
      var columnKey = genColumnKey(key, index);

      if (columnKey) {
        columnKeyMap[columnKey] = {
          show: true,
          fixed: fixed
        };
      }
    });
    return columnKeyMap;
  }, [props.columns]);

  var _useMergedState3 = useMergedState(function () {
    var _props$columnsState, _props$columnsState2;

    var _ref2 = props.columnsState || {},
        persistenceType = _ref2.persistenceType,
        persistenceKey = _ref2.persistenceKey;

    if (persistenceKey && persistenceType && typeof window !== 'undefined') {
      /** 从持久化中读取数据 */
      var storage = window[persistenceType];

      try {
        var storageValue = storage === null || storage === void 0 ? void 0 : storage.getItem(persistenceKey);

        if (storageValue) {
          return JSON.parse(storageValue);
        }
      } catch (error) {
        console.warn(error);
      }
    }

    return props.columnsStateMap || ((_props$columnsState = props.columnsState) === null || _props$columnsState === void 0 ? void 0 : _props$columnsState.value) || ((_props$columnsState2 = props.columnsState) === null || _props$columnsState2 === void 0 ? void 0 : _props$columnsState2.defaultValue) || defaultColumnKeyMap;
  }, {
    value: ((_props$columnsState3 = props.columnsState) === null || _props$columnsState3 === void 0 ? void 0 : _props$columnsState3.value) || props.columnsStateMap,
    onChange: ((_props$columnsState4 = props.columnsState) === null || _props$columnsState4 === void 0 ? void 0 : _props$columnsState4.onChange) || props.onColumnsStateChange
  }),
      _useMergedState4 = _slicedToArray(_useMergedState3, 2),
      columnsMap = _useMergedState4[0],
      setColumnsMap = _useMergedState4[1];

  noteOnce(!props.columnsStateMap, 'columnsStateMap已经废弃，请使用 columnsState.value 替换');
  noteOnce(!props.columnsStateMap, 'COLUMNSSTATEMAP has been discarded, please use columnSstate.value replacement');
  /** 清空一下当前的 key */

  var clearPersistenceStorage = useCallback(function () {
    var _ref3 = props.columnsState || {},
        persistenceType = _ref3.persistenceType,
        persistenceKey = _ref3.persistenceKey;

    if (!persistenceKey || !persistenceType || typeof window === 'undefined') return;
    /** 给持久化中设置数据 */

    var storage = window[persistenceType];

    try {
      storage === null || storage === void 0 ? void 0 : storage.removeItem(persistenceKey);
    } catch (error) {
      console.warn(error);
    }
  }, [props.columnsState]);
  useEffect(function () {
    var _props$columnsState5, _props$columnsState6;

    if (!((_props$columnsState5 = props.columnsState) === null || _props$columnsState5 === void 0 ? void 0 : _props$columnsState5.persistenceKey) || !((_props$columnsState6 = props.columnsState) === null || _props$columnsState6 === void 0 ? void 0 : _props$columnsState6.persistenceType)) {
      return;
    }

    if (typeof window === 'undefined') return;
    /** 给持久化中设置数据 */

    var _props$columnsState7 = props.columnsState,
        persistenceType = _props$columnsState7.persistenceType,
        persistenceKey = _props$columnsState7.persistenceKey;
    var storage = window[persistenceType];

    try {
      storage === null || storage === void 0 ? void 0 : storage.setItem(persistenceKey, JSON.stringify(columnsMap));
    } catch (error) {
      console.error(error);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [(_props$columnsState8 = props.columnsState) === null || _props$columnsState8 === void 0 ? void 0 : _props$columnsState8.persistenceKey, columnsMap, (_props$columnsState9 = props.columnsState) === null || _props$columnsState9 === void 0 ? void 0 : _props$columnsState9.persistenceType]);
  return {
    action: actionRef,
    setAction: function setAction(newAction) {
      actionRef.current = newAction;
    },
    sortKeyColumns: sortKeyColumns,
    setSortKeyColumns: function setSortKeyColumns(keys) {
      sortKeyColumns.current = keys;
    },
    propsRef: propsRef,
    columnsMap: columnsMap,
    keyWords: keyWords,
    setKeyWords: function setKeyWords(k) {
      return _setKeyWords(k);
    },
    setTableSize: setTableSize,
    tableSize: tableSize,
    prefixName: prefixNameRef.current,
    setPrefixName: function setPrefixName(name) {
      prefixNameRef.current = name;
    },
    setColumnsMap: setColumnsMap,
    columns: props.columns,
    clearPersistenceStorage: clearPersistenceStorage
  };
}

var Container = createContainer(useContainer);
export { useContainer };
export default Container;